import request from '@/utils/request'

export function getChapterListByBook (data) {
  return request({
    url: `/platform/bookChapter/listByBookId?pageIndex=${data.pageIndex}&pageSize=${data.pageSize}&bookId=${data.bookId}`,
    method: 'get'
  })
}

export function addBookChapter (data) {
  return request({
    url: `/platform/bookChapter`,
    method: 'post',
    data
  })
}

export function editBookChapter (data) {
  return request({
    url: `/platform/bookChapter/${data.id}`,
    method: 'patch',
    data
  })
}

export function delBookChapter (id) {
  return request({
    url: `/platform/bookChapter/${id}`,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/bookChapter.js